import * as React from 'react';
import { APIError } from '../../api';
import { ErrorName } from '../../enums/ErrorName';
import { AlertType } from '../../types/AlertType';
import { Alert } from 'rcd-cpp-ui/ui/alert/Alert';

interface AdditionalInfo {
  reqLogId: string;
  endpoint: string;
}

export class Neo4jError extends APIError<AdditionalInfo> {
  constructor(
    message: string,
    info: AdditionalInfo,
    type: AlertType = 'error'
  ) {
    super(message, info, type, ErrorName.Neo4jError);
  }
}

type Props = { error: Neo4jError; onClose: () => void };

export const Neo4jAlert = ({ error, onClose }: Props) => {
  const { reqLogId, endpoint } = error.additionalInfo;
  return (
    <Alert type={error.type as any} onClose={onClose}>
      <div>Failed to process request</div>
      <div>
        Request Path:
        <i> {endpoint}</i>
      </div>
      <div>
        Request Id:
        <i> {reqLogId}</i>
      </div>
    </Alert>
  );
};
